import React from 'react';

const IndustriesWeServe = () => {
  const industries = [
    {
      name: "Information Technology",
      description: "An IT profession with high skill levels does more than merely build the essential fundamental business infrastructure. They work on creating modern solutions to cut energy usage and offer enterprise-wide technologies for knowledge transfer.",
      icon: "💻",
      image: "it-industry.jpg"
    },
    {
      name: "Accounting & Finance",
      description: "Every day, your company deals with a variety of accounting and financial issues, and managing these procedures well is crucial to the expansion of your enterprise. To ensure that you succeed, we assist you in hiring the top experts.",
      icon: "📊",
      image: "accounting-finance.jpg"
    },
    {
      name: "Engineering",
      description: "You might not have the necessary resources to hire the best engineering team for your company. You don't want to hire unqualified employees that can't do the job! We employ a top-notch hiring procedure that can meet all of your needs.",
      icon: "⚙️",
      image: "engineering.jpg"
    },
    {
      name: "C-Level Executive",
      description: "Senior leadership jobs are held by C-level or C-suite executives within an organisation. They take significant actions to expand the businesses and alter the way the business runs for the long term.",
      icon: "👨‍💼",
      image: "c-level.jpg"
    },
    {
      name: "Legal",
      description: "Legal services are a vital need for businesses in every industry. Technology and globalisation together have created an environment that is dynamic and rapidly evolving for this profession.",
      icon: "⚖️",
      image: "legal.jpg"
    },
    {
      name: "Staffing And Recruitment",
      description: "By effectively managing your talent, you can optimize each employee's potential, increase your revenue, and keep your top performers. We help you find the right staff to manage these crucial responsibilities.",
      icon: "👥",
      image: "staffing.jpg"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Industries We Serve
          </h2>
          <p className="text-2xl text-blue-600 font-semibold mb-6">
            Leading Your Organization Into the Future With Confidence
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {industries.map((industry, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden group">
              {/* Image Placeholder */}
              <div className="h-40 bg-gradient-to-br from-blue-600 to-cyan-500 relative overflow-hidden">
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="text-center text-white">
                    <div className="text-3xl mb-2">{industry.icon}</div>
                    <p className="text-sm opacity-90">{industry.image}</p>
                  </div>
                </div>
              </div>
              
              {/* Content */}
              <div className="p-6">
                <div className="flex items-center mb-3">
                  <div className="text-2xl mr-3">{industry.icon}</div>
                  <h3 className="text-lg font-bold text-gray-900">{industry.name}</h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {industry.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesWeServe;